// src/pages/Reports/IssuanceReporting/ReconciliationDiscrepancy/index.tsx
// README.md mục 7 — trang "Đối soát & Chênh lệch": RPT-009 (đối soát đại lý, workflow xác nhận),
// RPT-010 (chênh lệch, ghi nhận + xử lý), RPT-014 (vé hủy, chỉ đọc).

import React, { useState } from 'react';
import { Card, CardBody, CardHeader, Container, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';

import BreadCrumb from 'Components/Common/BreadCrumb';
import { useBrandingTitle } from 'hooks';
import AgentReconciliationTab from './AgentReconciliationTab';
import TicketDiscrepancyTab from './TicketDiscrepancyTab';
import TicketCancellationTab from './TicketCancellationTab';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('reports_issuance_reporting');

type TabKey = 'reconciliation' | 'discrepancy' | 'cancellation';

const TABS: { key: TabKey; label: string }[] = [
  { key: 'reconciliation', label: st('doi_soat_dai_ly_label') },
  { key: 'discrepancy', label: st('chenh_lech_column') },
  { key: 'cancellation', label: st('ve_huy_label') },
];

const ReconciliationDiscrepancyPage: React.FC = () => {
  useBrandingTitle(st('doi_soat_chenh_lech_text'));
  const [activeTab, setActiveTab] = useState<TabKey>('reconciliation');

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={st('doi_soat_chenh_lech_text')} pageTitle={st('bao_cao_phat_hanh_text')} />

        <Card>
          <CardHeader className="card-header border-0">
            <Nav tabs className="nav-tabs-custom card-header-tabs flex-wrap">
              {TABS.map((tab) => (
                <NavItem key={tab.key}>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === tab.key })}
                    onClick={(e) => { e.preventDefault(); setActiveTab(tab.key); }}
                  >
                    {tab.label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </CardHeader>
          <CardBody>
            {activeTab === 'reconciliation' && <AgentReconciliationTab />}
            {activeTab === 'discrepancy' && <TicketDiscrepancyTab />}
            {activeTab === 'cancellation' && <TicketCancellationTab />}
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default ReconciliationDiscrepancyPage;
